import EpiApiClient from "@/services/serviceClients/epiApiClient";
import { 
  WEATHER_BRANCHES_API_PATH,
  BRANCHES_DETAILS_API_PATH,
  BRANCH_SHIP_TO_ADDRESSES_API_PATH,
  BRANCH_ALL_BY_USER_ID_API_PATH
} from "@/config/constants";

class BranchService {
  static async getBranchInfoByBranchCode(branchId) {
    try {
      const response = await EpiApiClient.get(`${BRANCHES_DETAILS_API_PATH}/${encodeURIComponent(branchId)}`);
      return { success: true, data: response.data };
    } catch (error) {
      const errorMessage = error.response?.data?.error_description || error.message || "request failed";
      console.error('BranchService.getBranchInfoByBranchCode failed:', errorMessage, error);
      return { success: false, error: errorMessage };
    }
  }

  static async searchBranches(searchTerm, currLat, currLong, take, showHomeBranchFirst) {
    try {
      const response = await EpiApiClient.get(
        `${WEATHER_BRANCHES_API_PATH}`,
        {
          params: {
            term: searchTerm,
            currentLatitude: currLat,
            currentLongitude: currLong,
            take: take,
            showHomeBranchFirst: showHomeBranchFirst
          }
        }
      );
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error_description || error.message || "request failed",
      };
    }
  }

  static async getShipToAddressesForBranches() {
    try {
      const response = await EpiApiClient.get(BRANCH_SHIP_TO_ADDRESSES_API_PATH);
      return { success: true, data: response.data };
    } catch (error) {
      const errorMessage = error.response?.data?.error_description || error.message || "request failed";
      console.error('BranchService.getShipToAddressesForBranches failed:', errorMessage, error);
      return { success: false, error: errorMessage };
    }
  }

  static async getAllBranchesByUserId(currentLatitude, currentLongitude, userId, term = '') {
    try {
      const response = await EpiApiClient.get(BRANCH_ALL_BY_USER_ID_API_PATH, {
        params: { currentLatitude, currentLongitude, userId, term }
      });
      return { success: true, data: response.data };
    } catch (error) {
      const errorMessage = error.response?.data?.error_description || error.message || "request failed";
      console.error('BranchService.getAllBranchesByUserId failed:', errorMessage, error);
      return { success: false, error: errorMessage };
    }
  }

}

export default BranchService;
